import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useNavigate, useParams } from 'react-router-dom'

import AddBeneficiaryModal from '@components/modal/addBeneficiaryModal'
import LoadingModal from '@components/loading/loadingModal'
import PageHeader from '@components/pageHeader'
import ArrowBack from '@components/arrowBack'
import BeneficiaryAdd from './beneficiaryAdd'
import BeneficiaryTable from '@components/table/beneficiaryTable'
import Header from '@pages/companies/header'
import ClassificationMetrics from '@components/classificationMetrics'
// import MessageHistoryPanel from '@components/messageHistoryPanel'
import Loading from '@components/loading'
import colors from '@settings/styleSettings'

import {
  getBeneficiariesWithCollection as getBeneficiariesAction,
} from '@actions/beneficiary'
import { getCompany as getCompanyAction } from '@actions/company'
import { listMessages as listMessagesAction } from '@actions/notification'

import {
  Container, SearchContainer, Title, InfoCompany
} from './styles'
import { PanelContainer } from '../../companies/styles'

const defaultPageSize = 10

const BeneficiaryInfos = ({
  getBeneficiariesWithCollection,
  beneficiaries,
  authData,
  getCompany,
  company,
  listMessages,
}) => {
  const [loadingOverview, setLoadingOverview] = useState(false)
  const [allBeneficiaries, setAllBeneficiaries] = useState(null)
  const navigate = useNavigate()
  const [, setLoadingMessages] = useState(false)
  const [reportLoading, setReportLoading] = useState(false)
  const [addBeneficiaryModal, setAddBeneficiaryModal] = useState(false)
  const [filterState, setFilterState] = useState({
    highRisk: false,
    mediumRisk: false,
    lowRisk: false,
    noRisk: false,

    diabetic: false,
    amputation: false,
    diabeticFoot: false,
    nephropathy: false,
    type2: false,
    controlledGlycatedHemoglobin: false,
    diabeticFootEvaluated: false,
    alcohol: false,
    smoking: false,

    dyslipidemic: false,
    hypertensive: false,
    controlledHypertension: false,

    overweight: false,
    overweightInRecovery: false,
  })

  const { companyId } = useParams()
  const resolvedCompanyId = companyId || (authData && authData.company && authData.company.id)

  const searchBeneficiaries = (
    searchTerm,
    newPage,
    newPageSize = defaultPageSize,
    callback
  ) => {
    getBeneficiariesWithCollection(
      {
        page: newPage,
        ...filterState,
        searchTerm,
        pageSize: newPageSize,
        companyId: resolvedCompanyId,
      },
      () => callback && callback()
    )
  }

  useEffect(() => {
    // setLoadingOverview(true)
    if (!resolvedCompanyId) return
    getCompany(resolvedCompanyId, () => {
      setLoadingOverview(false)
    })
    listMessages(
      {
        pageSize: 3,
        page: 0,
        orderByDesc: true,
        orderByAsc: false,
        programmeId: 0,
        companyId: resolvedCompanyId,
      },
      () => setLoadingMessages(false)
    )
  }, [resolvedCompanyId])

  useEffect(() => {
    if (allBeneficiaries === null && beneficiaries !== null) {
      setAllBeneficiaries(beneficiaries)
    }
  }, [beneficiaries])

  const goBack = () => {
    navigate(-1)
  }

  const renderTitle = () => {
    if (company) return <Title>{`Empresa ${company.name}`}</Title>
    return <Title>{authData.company && `Empresa ${authData.company.name}`}</Title>
  }

  // const goToMessages = () => {
  //   navigate(`/${insurance}/acompanhamento/mensagens/empresa/${company.id}`)
  // }

  return (
    <Container>
      {authData.company ? <PageHeader /> : <Header />}
      <SearchContainer>
        <InfoCompany>
          {authData && !authData.company && <ArrowBack onClick={goBack} />}
          {renderTitle()}
        </InfoCompany>
        {loadingOverview ? (
          <Loading
            color={colors.primary}
            height={40}
            width={40}
            style={{ marginLeft: '12px' }}
          />
        ) : (
          <PanelContainer>
            <ClassificationMetrics
              beneficiaryFilter={filterState}
              setBeneficiaryFilter={setFilterState}
              companyId={{ companyId: resolvedCompanyId }}
            />
            {/* <MessageHistoryPanel
              goToMessages={goToMessages}
              loading={loadingMessages}
              slice={3}
            /> */}
          </PanelContainer>
        )}
        <BeneficiaryAdd openAddBeneficiaryModal={setAddBeneficiaryModal} />
        {addBeneficiaryModal && (
          <AddBeneficiaryModal
            isOpen={addBeneficiaryModal}
            company={{
              id: resolvedCompanyId,
            }}
            setClose={() => setAddBeneficiaryModal(false)}
          />
        )}
        <BeneficiaryTable
          onGetReport={(value) => setReportLoading(value)}
          setBeneficiaryFilterState={setFilterState}
          beneficiaryFilterState={filterState}
          searchBeneficiaries={searchBeneficiaries}
          companyId={resolvedCompanyId}
        />
      </SearchContainer>
      <LoadingModal isOpen={reportLoading} />
    </Container>
  )
}

BeneficiaryInfos.propTypes = {
  getBeneficiariesWithCollection: PropTypes.func.isRequired,
  beneficiaries: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      age: PropTypes.number,
      insuranceNumber: PropTypes.string,
      cpf: PropTypes.string,
      sex: PropTypes.string,
      birthdate: PropTypes.string,
      lastGeneralCollection: PropTypes.shape({
        collectedAt: PropTypes.string,
        height: PropTypes.number,
        weight: PropTypes.number,
        abdominalCircumference: PropTypes.number,
        waistCircumference: PropTypes.number,
        hipCircumference: PropTypes.number,
        fat: PropTypes.number,
        visceralFat: PropTypes.number,
        leanMass: PropTypes.number,
        calories: PropTypes.number,
        triglycerides: PropTypes.number,
        glucose: PropTypes.number,
        hdlCholesterol: PropTypes.number,
        ldlCholesterol: PropTypes.number,
        systBloodPressure: PropTypes.number,
        diastBloodPressure: PropTypes.number,
        totalCholesterol: PropTypes.number,
        notHdl: PropTypes.number,
        hasSystemicArterialHypertension: PropTypes.bool,
        hasDiabetes: PropTypes.bool,
      }),
    })
  ),
  authData: PropTypes.shape({
    company: PropTypes.shape({
      endPoint: PropTypes.string,
      id: PropTypes.number,
      name: PropTypes.string
    }),
  }),
  company: PropTypes.shape({
    endPoint: PropTypes.string,
    id: PropTypes.number,
    name: PropTypes.string
  }),
  getCompany: PropTypes.func.isRequired,
  listMessages: PropTypes.func.isRequired
}

BeneficiaryInfos.defaultProps = {
  beneficiaries: null,
  authData: null,
  company: null,
}

const mapStateToProps = ({ beneficiary, auth, company }) => ({
  beneficiaries: beneficiary.beneficiaries,
  total: beneficiary.total,
  authData: auth.data,
  company: company.company,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getBeneficiariesWithCollection: getBeneficiariesAction,
    getCompany: getCompanyAction,
    listMessages: listMessagesAction
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(BeneficiaryInfos)
